module.exports = __webpack_public_path__ + "img/mob3.03cc18f2.png";